<!-- eslint-disable max-len -->
<template>
<svg
    width="32" height="32" viewBox="0 0 32 32"
    fill="none" xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M3.98827 21.7883C4.18432 22.2828 4.22797 22.8247 4.1136 23.3443L2.6936 27.7309C2.64785 27.9534 2.65968 28.1839 2.72797 28.4005C2.79626 28.6171 2.91875 28.8127 3.08383 28.9686C3.2489 29.1246 3.45108 29.2359 3.6712 29.2918C3.89132 29.3477 4.12209 29.3465 4.3416 29.2883L8.89227 27.9576C9.38256 27.8604 9.89031 27.9029 10.3576 28.0803C13.2048 29.4099 16.4301 29.6912 19.4645 28.8746C22.4989 28.0579 25.1473 26.1958 26.9425 23.6168C28.7378 21.0377 29.5644 17.9075 29.2767 14.7783C28.9889 11.6492 27.6052 8.72223 25.3697 6.51387C23.1342 4.3055 20.1905 2.95766 17.0581 2.70814C13.9257 2.45861 10.8058 3.32345 8.24886 5.15006C5.69194 6.97667 3.86231 9.64766 3.08279 12.6918C2.30328 15.7359 2.62396 18.9575 3.98827 21.7883Z"
        stroke="currentColor" stroke-width="2.25" stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M12.1191 11.9949C12.4326 11.1038 13.0513 10.3524 13.8657 9.87374C14.6802 9.39511 15.6377 9.22015 16.5687 9.37985C17.4998 9.53955 18.3442 10.0236 18.9526 10.7463C19.5609 11.4689 19.8939 12.3836 19.8925 13.3282C19.8925 15.9949 15.8925 17.3282 15.8925 17.3282"
        stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M16 22.666H16.0133H16Z" fill="currentColor"
    />
    <path
        d="M16 22.666H16.0133" stroke="currentColor" stroke-width="3"
        stroke-linecap="round" stroke-linejoin="round"
    />
</svg>
</template>
